import axios from 'axios';

export class HttpUtils {
    constructor(){

    }


    static handleError(e){

        if (e == null)return;
        console.warn('[w883652] handleError method is deprecated, use HandleHttpError');
        HttpUtils.HandleHttpError(e);
    }


    static HandleHttpError(error) {

        if (error == null) {
            window.tracer.error("[e129161] expected an http error object.");
            return;
        }

        let response = error.response;

        if (error.response == null){
            window.tracer.error("[e129161] expected an http response object.");
            return;
        }


        let statusCode = error.response.status;

        if (statusCode === 200 ||
            statusCode === 201 ||
            statusCode === 202 ||
            statusCode === 204 ||
            statusCode === 404) {
            return;
        }

        if (statusCode === 401) {
            HttpUtils.Handle401();
            return;
        }

        if (statusCode === 403) {
            HttpUtils.Handle403();
            return;
        }

        window.tracer.httpError(error);
        HttpUtils.HandleErrorCode(error.response);
    }


    static HandleHttpErrorCode(errorCode, response){

        console.warn('[w784643] HandleHttpErrorCode method is deprecated, use HandleHttpError');
        if (errorCode == null){
            window.tracer.error("[e392201] expected an http error code, received an undefined value.");
            return;
        }

        if (errorCode === 401){
            HttpUtils.Handle401();
            return;
        }

        if (errorCode === 500){
            HttpUtils.Handle500(response);

            return;
        }

        if (errorCode === 400){
            HttpUtils.Handle400(response);
        }

        HttpUtils.HandleGenericCode();
    }



    static Handle500(response){

        console.warn('[w832176] Handle500 method is deprecated, use HandleHttpError');
        window.app.$notify.error({
            title: '[500] Server Error',
            message: window.config.api.errorsMessages["500"]
        });
    }

    static Handle401() {

        window.app.$notify.warning({
            title: 'Session Expired',
            message: window.config.api.errorsMessages["401"],
            duration: 9000
        });

        setTimeout(() => {
            location.reload()
        }, 1500);

    }

    static Handle403() {

        window.app.$notify.warning({
            title: 'Unauthorized',
            message: window.config.api.errorsMessages["403"],
            duration: 9000
        });

        setTimeout(() => {
            location.reload();
        }, 1500);

    }

    static Handle400(response) {

        console.warn('[w784643] HandleHttpErrorCode method is deprecated, use HandleHttpError');
        window.app.$notify.error({
            title: '[400] Server Error',
            message: window.config.api.errorsMessages["400"]
        });

    }

    static Handle422(response) {

        console.warn('[w784643] HandleHttpErrorCode method is deprecated, use HandleHttpError');
        window.app.$notify.error({
            title: '[422] Server Error',
            message: window.config.api.errorsMessages["422"]
        });

    }

    static handled404(e, func){
        if (e.response){
            if (e.response.status === 404){
                func();
                return true;
            }
        }

        return false;
    }

    static HandleErrorCode(response){

        let errorCode = response.status;
        let message = window.config.api.errorsMessages[errorCode];
        if (message == null){
            message = window.config.api.errorsMessages.generic;
        }

        window.app.$notify.error({
            title: `[${errorCode}] Server Error`,
            message: message
        });
    }


    static getHttpHeaders(auth, contentType){

        let headers = {};

        if (contentType){
            headers['content-type'] = contentType;
        }

        if (auth != null){
            if (auth.jwt == null){
                throw new Error("[e-424913] Auth object does not contain jwt.")
            }

            if (auth.sessionId == null){
                throw new Error("[e-700669] Auth object does not contain sessionId.")
            }
            headers['authorization'] = `Bearer ${auth.jwt}`;
            headers['x-app-session'] = auth.sessionId;
        }
        else{
            let sessionId = HttpUtils.getCookie("app-"+window.appInstanceId);
            if (sessionId != null) {
                headers['x-app-session'] = sessionId;
            }
        }

        headers['x-correlation-id'] = window.config.correlationId;
        headers['x-app-instance'] = window.appInstanceId;

        if (window.config.isIE11){
            headers['x-ie11'] = 1;
        }

        return headers;
    }

    static getSessionId(auth){
        return auth.sessionId;
    }

    static getInstanceId(){
        return window.appInstanceId;
    }

    static get(url, auth) {
        return new Promise((resolve, reject) => {
            try {
                let headers = HttpUtils.getHttpHeaders(auth, 'application/json');

                axios.get(url, {headers: headers}).then(response => {
                    if (response.status === 204) {
                        resolve(true);
                    } else if (response.status === 200 || response.status === 201 || response.status === 202 || response.status === 204) {
                        if (response.data == null) {
                            resolve(true);
                        } else {
                            resolve(response.data);
                        }
                    } else {
                        window.tracer.error(`[e229362] ${response.status} not supported.`);
                        reject(response.status);
                    }
                }).catch((e) => {
                    if (e.response) {

                        if (e.response.status === 404) {
                            console.debug('[d465294] 404 - resource not found. url: ' + url);
                            resolve(null);
                            return;
                        }
                    }

                    HttpUtils.HandleHttpError(e);
                    reject(e);
                });
            } catch (err) {

                window.tracer.error('[e118485-ADM] HttpUtils.get exception!');
                if (!err) {
                    window.tracer.error(err);
                }

                reject(err);
            }
        });
    }

    static postAuth(url, payload){
        return new Promise((resolve, reject) => {

                try {

                    let headers = HttpUtils.getHttpHeaders(null, 'application/json');

                    axios.post(url, payload, {headers: headers}).then(response => {
                        if (response.status === 204) {
                            resolve(true);
                        } else if (response.status === 200 || response.status === 201 || response.status === 202 || response.status === 204) {
                            if (response.data == null){
                                resolve(true);
                            }
                            else {
                                resolve(response.data);
                            }
                        } else {
                            throw new Error(`[e-427370] ${response.status} currently not supported on HttpUtils`);
                        }

                    }).catch( e => {

                        if (e != null && e.response != null) {
                            if (e.response.status === 404) {
                                window.tracer.warn('[e-940057] 404 - resource not found. url: ' + url);
                                reject();
                                return;
                            }
                            else if (e.response.status === 401 || e.response.status === 403) {
                                window.tracer.warn(`[e-348878] ${e.response.status} Status`);
                                reject();
                                return;
                            }
                        }

                        if (e != null) {
                            window.tracer.error(e);
                        }

                        reject(e);
                    });
                } catch (err) {

                    window.tracer.error('[e-302668] HttpUtils.postAuth exception!');
                    if (!err) {
                        window.tracer.error(err);
                    }

                    reject(err);
                }
            }
        );
    }

    static post(url, auth, payload){

        return new Promise((resolve, reject) => {

                try {
                    let headers = HttpUtils.getHttpHeaders(auth, 'application/json');


                    axios.post(url, payload, {headers: headers}).then(response => {
                        if (response.status === 204) {
                            resolve(true);
                        } else if (response.status === 200 || response.status === 201 || response.status === 202 || response.status === 204) {
                            if (response.data == null){
                                resolve(true);
                            }
                            else {
                                resolve(response.data);
                            }
                        } else {
                            window.tracer.error(`[e229362] ${response.status} not supported.`);
                            reject(response.status);
                        }

                    }).catch((e) => {
                        if (e.response) {
                            if (e.response.status === 404) {
                                console.warn('[w006101] 404 - resource not found. url: ' + url);
                                resolve(null);
                                return;
                            }
                        }

                        HttpUtils.HandleHttpError(e);
                        reject(e);
                    });
                } catch (err) {

                    window.tracer.error('[e389044] HttpUtils.put exception!');
                    if (!err) {
                        window.tracer.error(err);
                    }

                    reject(err);
                }
            }
        );

    }


    static put(url, auth, payload){

        return new Promise((resolve, reject) => {

                try {
                    let headers = HttpUtils.getHttpHeaders(auth, 'application/json');


                    axios.put(url, payload, {headers: headers}).then(response => {
                        if (response.status === 204) {
                            resolve(true);
                        } else if (response.status === 200 || response.status === 201 || response.status === 202) {
                            if (response.data == null){
                                resolve(true);
                            }
                            else {
                                resolve(response.data);
                            }
                        } else {
                            window.tracer.error(`[e229362] ${response.status} not supported.`);
                            reject(response.status);
                        }

                    }).catch((e) => {
                        if (e.response) {
                            if (e.response.status === 404) {
                                console.warn('[w465294] 404 - resource not found. url: ' + url);
                                resolve(false);
                                return;
                            }
                        }

                        HttpUtils.HandleHttpError(e);
                        reject(e);
                    });
                } catch (err) {

                    window.tracer.error('[e389044] HttpUtils.put exception!');
                    if (!err) {
                        window.tracer.error(err);
                    }

                    reject(err);
                }
            }
        );

    }

    static head(url, auth){

        return new Promise((resolve, reject) => {

            let headers = HttpUtils.getHttpHeaders(auth, 'application/json');

            axios.head(url, {headers: headers}).then(response => {
                if (response.status === 204 || response.status === 200 || response.status === 201 || response.status === 202){
                    resolve(true);
                }
                else {
                    window.tracer.error(`[e802525] ${response.status} not support.`);
                    throw new Error(`${response.status} not supported by HttpUtils helpers for head actions`);
                }

            }).catch((e) => {
                if (e.response) {
                    if (e.response.status === 404) {
                        console.warn('[w566298] 404 - resource not found. url: '+url);
                        resolve(false);
                        return;
                    }

                }

                HttpUtils.HandleHttpError(e);
                reject(e);
            });
        });
    }

    static delete(url, auth){
        return new Promise((resolve, reject) => {

            let headers = HttpUtils.getHttpHeaders(auth, 'application/json');

            axios.delete(url, {headers: headers}).then(response => {
                if (response.status === 204) {
                    resolve(true);
                } else if (response.status === 200 || response.status === 201 || response.status === 202 || response.status === 204) {
                    if (response.data == null){
                        resolve(true);
                    }
                    else {
                        resolve(response.data);
                    }
                } else {
                    window.tracer.error(`[e229362] ${response.status} not supported.`);
                    reject(response.status);
                }

            }).catch((e) => {
                if (e.response) {
                    if (e.response.status === 404) {
                        console.warn('[w465294] 404 - resource not found. url: '+url);
                        resolve(false);
                        return;
                    }
                }

                HttpUtils.HandleHttpError(e);
                reject(e);

            });
        });
    }


    static setCookie(name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }

        document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Strict";
    }

    static getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);

            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }

        window.tracer.debug("[d-597193] session cookie not found");
        return null;
    }

    static deleteCookie(name){

        document.cookie = name + "=''; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Strict";
    }
}

